export function header() {
  const burger = document.getElementById('headerBurger');
  const nav = document.getElementById('headerNav');

  if (!burger || !nav) return;

  burger.addEventListener('click', () => {
    const isOpen = nav.classList.toggle('is-open');
    burger.classList.toggle('is-active');
    burger.setAttribute('aria-expanded', isOpen);
    document.body.classList.toggle('scroll-lock', isOpen);
  });

  // Close menu when a nav link is clicked
  nav.querySelectorAll('.menu-item a').forEach((link) => {
    link.addEventListener('click', () => {
      nav.classList.remove('is-open');
      burger.classList.remove('is-active');
      burger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('scroll-lock');
    });
  });
}
